import { Row, Col, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Loading from './Loading';
import classNames from 'classnames';
import _ from 'lodash';


/**
 *
 * This component manages:
 * - Bootstrap structure and classes
 * - A loading indicator
 * - A <Label> for the field
 * - Label help text
 * - Validation error style and display
 *
 * The form input itself should be passed as content.
 */

class FormField extends PureComponent {
    render() {
        const {field = {}, required, help, inputClass, label, loading, forceFullSize, style, inputSize, labelSize} = this.props;
        const error = field.touched && field.error;
        const warning = field.warning;
        let labelTag = '';
        const inputSm = inputSize || 12;

        const wrapHelp = (input) => {
            if (!help) {
                return input;
            }

            const tooltip = (<Tooltip id={_.uniqueId('tooltip_')}>{help}</Tooltip>);
            return (
                <OverlayTrigger placement="bottom"
                                overlay={tooltip}
                                delayShow={50}
                                delayHide={50}
                                trigger={['hover', 'focus']}
                >
                    <span>
                        {input}
                        <Glyphicon glyph="info-sign"
                                   tabIndex={0}
                                   style={{marginLeft: 6, cursor: 'help', color: '#888', fontSize: '0.9em'}}
                        />
                    </span>
                </OverlayTrigger>);
        };

        if (label) {
            let loadingTag = '';
            if (loading) {
                loadingTag = (<Loading inline/>);
            }

            const labelComponent = wrapHelp(<label data-hj-whitelist htmlFor={field.name}>{label}{required ? ' *' : ''}</label>);
            labelTag = (
            <Col md={labelSize || 12} xs={12} className="control-label" style={{textAlign: 'left'}}>
                {loadingTag}
                {labelComponent}
            </Col>);
        }

        let result = '';
        if (label === undefined) {
            result = (
                <div id={field.name} className={classNames('form-group', {'has-error': error}, {'has-warning': warning})}>
                    {this.props.children}
                    <p className="help-block" style={{marginBottom: '0px'}}>{error}</p>
                    <p className="help-block" style={{marginBottom: 0}}>{warning}</p>
                </div>);
        } else if (forceFullSize) {
            result =  (
            <Col id={field.name} xs={12}>
                <Row className={classNames('form-group', {'has-error': error}, {'has-warning': warning})}>
                {labelTag}
                </Row>
                <Row>
                <Col xs={12} className={inputClass}>
                    {this.props.children}
                    {error && <p className="help-block" style={{marginBottom: 0}}>{error}</p>}
                    {warning && <p className="help-block" style={{marginBottom: 0}}>{warning}</p>}
                </Col>
                </Row>
            </Col>);
        } else {
            result =  (
            <Col id={field.name} xs={12}>
            <Row className={classNames('form-group', {'has-error': error}, {'has-warning': warning})}>
                {labelTag}
                <Col md={inputSm} xs={12} className={inputClass}>
                    {this.props.children}
                    {error && <p className="help-block" style={{marginBottom: 0}}>{error}</p>}
                    {warning && <p className="help-block" style={{marginBottom: 0}}>{warning}</p>}
                </Col>
            </Row>
            </Col>);
        }

        if (style) {
            result = (
                <div style={style}>{result}</div>
            );
        }

        return result;
    }
};


FormField.propTypes = {
    field: PropTypes.object,
    // Help text to be displayed next to the label
    help: PropTypes.string,
    // An additional class to be applied to the input container
    inputClass: PropTypes.string,

    // Label text
    label: PropTypes.string,
    // Loading state
    loading: PropTypes.bool,
    labelWidth: PropTypes.number
};

FormField.defaultProps = {
     field: {},
     inputProps: {}
};

export default FormField;